<h1 mat-dialog-title>{{initialized ? data.title : "Loading..."}}</h1>
<div mat-dialog-content>
  @if (!initialized) {
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  }
  @if (initialized) {
    <div class="text-end">
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Company name</mat-label>
          <input matInput type="text" placeholder="Start typing.." [formControl]="companyNameFilter" />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
      </p>
    </div>
    <mat-paginator [pageSizeOptions]="[5 ,10, 15]" [pageIndex]="page-1" [pageSize]="limit"
      [length]="totalNumberOfCompanies" showFirstLastButtons (page)="onPageChange($event)"
      aria-label="Select page of companies">
    </mat-paginator>
    <div class="py-2">
      <mat-divider></mat-divider>
    </div>
    <table mat-table [dataSource]="companiesDataSource" class="company-list">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let selectable">{{ selectable.company.name }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let selectable">{{ getType(selectable.company) }}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let selectable">{{ selectable.company.email ? selectable.company.email : '-'
        }}</td>
      </ng-container>
      <ng-container matColumnDef="phone_number">
        <th mat-header-cell *matHeaderCellDef>Phone number</th>
        <td mat-cell *matCellDef="let selectable">{{ selectable.company.phone_number ?
        selectable.company.phone_number : '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let selectable"> {{formatTime(selectable.company.created_at)}} </td>
      </ng-container>
      <ng-container matColumnDef="selected">
        <th mat-header-cell *matHeaderCellDef>Selected</th>
        <td mat-cell *matCellDef="let selectable">
          <mat-checkbox [disableRipple]="true" (click)="$event.preventDefault()" color="primary"
          [checked]="selectable.selected"></mat-checkbox>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr [class.selected]="row.selected" mat-row (click)="selectCompany(row)"
      *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="null">Cancel</button>
  <button mat-raised-button [disabled]="!selectedCompany || isLoading" [mat-dialog-close]="selectedCompany"
  color="primary" cdkFocusInitial>Apply</button>
</div>